export const habaAltText = {
  altText: {
    habaLogo: 'Wehrfritz',
    slowRequestWatchClock: 'Request icon – represents order or inquiry process at HABA Play',
    paymentLogo: {
      advancePayment: 'Prepayment icon – pay by bank transfer at HABA Play',
      ct_creditcard_hop: 'Mastercard and Visa logos – pay by credit card at HABA Play',
      ct_paypal: 'PayPal logo – secure online payment at HABA Play',
      paypalInstallment: 'PayPal installment logo – flexible payment in installments at HABA Play',
      debit: 'Direct debit icon – pay via bank withdrawal at HABA Play',
      invoice: 'Invoice icon – pay by invoice at HABA Play',
      fallback: 'Payment icon – represents secure payment at HABA Play',
    },
  },
};
